/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

export const VenueLabel: FcWithoutChildren = () => (
  // TODO: 多言語対応 https://github.com/balus-co-ltd/spwn/issues/11159
  <p css={rootStyle}>会場受け取り商品</p>
);

const rootStyle = css`
  border: 1px solid #a3a3a3;
  color: #000;
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  padding: 5px 12px;
`;
